<template>
  <scroll-bar style="margin-top:80px;">
      <sidebar-item :routes="routes"></sidebar-item>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  computed: {
    ...mapGetters([
      'sidebar',
      'routers'
    ]),
    routes() {
      return this.routers
    }
  }
}
</script>

<style scoped>
.bottom-sidebar {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/BottomSidebar/index.vue